import { Button, colors } from "goi_common";
import { ReactNode } from "react";

interface HomeV4PrimaryButtonProps {
  children: ReactNode;
  onClick?: () => void;
  background?: string;
  disabled?: boolean;
}

export default function HomeV4PrimaryButton({
  children,
  onClick,
  background = colors.orange650,
  disabled = false,
}: HomeV4PrimaryButtonProps) {
  return (
    <Button
      className="body_16_m"
      onClick={onClick}
      css={{
        borderRadius: "8px",
        background,
        color: colors.white,
        padding: "12px 24px",
      }}
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
